export default "__VITE_ASSET__Srrz0970__"